import React from 'react';
import { motion } from 'framer-motion';
export function AboutFreddy() {
  return <section className="py-24 px-6 bg-teal-950" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="md:col-span-5 flex justify-center" data-id="element-19">
            <div className="w-64 h-64 md:w-80 md:h-80 rounded-full bg-teal-900 relative overflow-hidden shadow-2xl border-4 border-gold/30 ring-1 ring-cream/10" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/f3ifF8pDBbzkfk1zG26rAS/Slow_Living_Instagram_Reel_in_Minimal_Style_(Post_para_Instagram_(45))_(Post_para_Instagram_(45))_(1).png" alt="Freddy Pimentel — Coach de Vida y de Pareja" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-21" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="md:col-span-7 space-y-6" data-id="element-22">
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-2 text-cream" data-id="element-23">
              Hola, soy{' '}
              <span className="italic text-terracotta" data-id="element-24">Freddy Pimentel</span>
            </h2>

            <p className="text-lg text-cream/80 leading-relaxed" data-id="element-25">
              Y durante mucho tiempo vi cómo muchas personas confundían amor con
              dependencia emocional.
            </p>

            <p className="text-lg text-cream/80 leading-relaxed" data-id="element-26">
              Por eso creé el:
            </p>

            <h3 className="text-2xl font-serif text-cream my-6" data-id="element-27">
              MÉTODO F.O.D.A
            </h3>

            <p className="text-lg text-cream/80 leading-relaxed" data-id="element-28">
              Un proceso de despertar y reconstrucción emocional diseñado para
              ayudar a hombres y mujeres a recuperar su paz, claridad y poder
              interior.
            </p>

            <div className="pt-6 border-t border-cream/10 mt-8" data-id="element-29">
              <p className="text-lg text-cream/80 mb-4" data-id="element-30">
                Este entrenamiento no es una simple charla motivacional.
              </p>
              <h4 className="text-2xl md:text-3xl font-serif leading-tight text-cream" data-id="element-31">
                ES UNA EXPERIENCIA EMOCIONAL
                <br data-id="element-32" />
                <span className="italic text-terracotta" data-id="element-33">
                  QUE PUEDE AYUDARTE A VOLVER A TI.
                </span>
              </h4>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}